import { _scrollers as A, Observer as Ne, _vertical as fe, _horizontal as Fe, _getTarget as be, _getProxyProp as ot, _getScrollFunc as Ct, _proxies as zt, _getVelocityProp as Ln } from "./td-longtail-vue-components250.js";
/*!
 * ScrollTrigger 3.12.2
 * https://greensock.com
 *
 * @license Copyright 2008-2023, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/
var u, vt, y, F, Ie, M, wn, hr, gr, mt, lr, Qt, ne, vr, Fr, le, tn, rn, wt, mn, Er, bn, xe, xn, Cn, yn, je, Nr, Yr, bt, Ur, Mr, Zt = 1, ue = Date.now, Ar = ue(), Ae = 0, At = 0, nn = function(e, n, r) {
  var t = ye(e) && (e.substr(0, 6) === "clamp(" || e.indexOf("max") > -1);
  return r["_" + n + "Clamp"] = t, t ? e.substr(6, e.length - 7) : e;
}, on = function(e, n) {
  return n && (!ye(e) || e.substr(0, 6) !== "clamp(") ? "clamp(" + e + ")" : e;
}, Hn = function s() {
  return At && requestAnimationFrame(s);
}, sn = function() {
  return vr = 1;
}, ln = function() {
  return vr = 0;
}, Ye = function(e) {
  return e;
}, Ot = function(e) {
  return Math.round(e * 1e5) / 1e5 || 0;
}, Sn = function() {
  return typeof window < "u";
}, Tn = function() {
  return u || Sn() && (u = window.gsap) && u.registerPlugin && u;
}, ft = function(e) {
  return !!~wn.indexOf(e);
}, kn = function(e) {
  return (e === "Height" ? Ur : y["inner" + e]) || Ie["client" + e] || M["client" + e];
}, Rn = function(e) {
  return ot(e, "getBoundingClientRect") || (ft(e) ? function() {
    return dr.width = y.innerWidth, dr.height = Ur, dr;
  } : function() {
    return qe(e);
  });
}, Wn = function(e, n, r) {
  var t = r.d, o = r.d2, a = r.a;
  return (a = ot(e, "getBoundingClientRect")) ? function() {
    return a()[t];
  } : function() {
    return (n ? kn(o) : e["client" + o]) || 0;
  };
}, Yn = function(e, n) {
  return !n || ~zt.indexOf(e) ? Rn(e) : function() {
    return dr;
  };
}, Ge = function(e, n) {
  var r = n.s, t = n.d2, o = n.d, a = n.a;
  return Math.max(0, (r = "scroll" + t) && (a = ot(e, r)) ? a() - Rn(e)()[o] : ft(e) ? (Ie[r] || M[r]) - kn(t) : e[r] - e["offset" + t]);
}, jt = function(e, n) {
  for (var r = 0; r < wt.length; r += 3)
    (!n || ~n.indexOf(wt[r + 1])) && e(wt[r], wt[r + 1], wt[r + 2]);
}, ye = function(e) {
  return typeof e == "string";
}, ce = function(e) {
  return typeof e == "function";
}, ar = function(e) {
  return typeof e == "number";
}, nt = function(e) {
  return typeof e == "object";
}, Mt = function(e, n, r) {
  return e && e.progress(n ? 0 : 1) && r && e.pause();
}, Or = function(e, n) {
  if (e.enabled) {
    var r = n(e);
    r && r.totalTime && (e.callbackAnimation = r);
  }
}, gt = Math.abs, Pn = "left", En = "top", Vr = "right", Xr = "bottom", st = "width", lt = "height", It = "Right", Ft = "Left", Nt = "Top", Bt = "Bottom", W = "padding", Ee = "margin", yt = "Width", qr = "Height", J = "px", Me = function(e) {
  return y.getComputedStyle(e);
}, Un = function(e) {
  var n = Me(e).position;
  e.style.position = n === "absolute" || n === "fixed" ? n : "relative";
}, an = function(e, n) {
  for (var r in n)
    r in e || (e[r] = n[r]);
  return e;
}, qe = function(e, n) {
  var r = n && Me(e)[Fr] !== "matrix(1, 0, 0, 1, 0, 0)" && u.to(e, {
    x: 0,
    y: 0,
    xPercent: 0,
    yPercent: 0,
    rotation: 0,
    rotationX: 0,
    rotationY: 0,
    scale: 1,
    skewX: 0,
    skewY: 0
  }).progress(1), t = e.getBoundingClientRect();
  return r && r.progress(0).kill(), t;
}, Br = function(e, n) {
  var r = n.d2;
  return e["offset" + r] || e["client" + r] || 0;
}, Mn = function(e) {
  var n = [], r = e.labels, t = e.duration(), o;
  for (o in r)
    n.push(r[o] / t);
  return n;
}, Vn = function(e) {
  return function(n) {
    return u.utils.snap(Mn(e), n);
  };
}, Gr = function(e) {
  var n = u.utils.snap(e), r = Array.isArray(e) && e.slice(0).sort(function(t, o) {
    return t - o;
  });
  return r ? function(t, o, a) {
    a === void 0 && (a = 1e-3);
    var l;
    if (!o)
      return n(t);
    if (o > 0) {
      for (t -= a, l = 0; l < r.length; l++)
        if (r[l] >= t)
          return r[l];
      return r[l - 1];
    } else
      for (l = r.length, t += a; l--; )
        if (r[l] <= t)
          return r[l];
    return r[0];
  } : function(t, o, a) {
    a === void 0 && (a = 1e-3);
    var l = n(t);
    return !o || Math.abs(l - t) < a || l - t < 0 == o < 0 ? l : n(o < 0 ? t - e : t + e);
  };
}, Xn = function(e) {
  return function(n, r) {
    return Gr(Mn(e))(n, r.direction);
  };
}, er = function(e, n, r, t) {
  return r.split(",").forEach(function(o) {
    return e(n, o, t);
  });
}, X = function(e, n, r, t, o) {
  return e.addEventListener(n, r, {
    passive: !t,
    capture: !!o
  });
}, V = function(e, n, r, t) {
  return e.removeEventListener(n, r, !!t);
}, tr = function(e, n, r) {
  r = r && r.wheelHandler, r && (e(n, "wheel", r), e(n, "touchmove", r));
}, fn = {
  startColor: "green",
  endColor: "red",
  indent: 0,
  fontSize: "16px",
  fontWeight: "normal"
}, rr = {
  toggleActions: "play",
  anticipatePin: 0
}, _r = {
  top: 0,
  left: 0,
  center: 0.5,
  bottom: 1,
  right: 1
}, fr = function(e, n) {
  if (ye(e)) {
    var r = e.indexOf("="), t = ~r ? +(e.charAt(r - 1) + 1) * parseFloat(e.substr(r + 1)) : 0;
    ~r && (e.indexOf("%") > r && (t *= n / 100), e = e.substr(0, r - 1)), e = t + (e in _r ? _r[e] * n : ~e.indexOf("%") ? parseFloat(e) * n / 100 : parseFloat(e) || 0);
  }
  return e;
}, nr = function(e, n, r, t, o, a, l, c) {
  var C = o.startColor, L = o.endColor, O = o.fontSize, d = o.indent, f = o.fontWeight, w = F.createElement("div"), ie = ft(r) || ot(r, "pinType") === "fixed", oe = e.indexOf("scroller") !== -1, he = ie ? M : r, H = e.indexOf("start") !== -1, pe = H ? C : L, m = "border-color:" + pe + ";font-size:" + O + ";color:" + pe + ";font-weight:" + f + ";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";
  return m += "position:" + ((oe || c) && ie ? "fixed;" : "absolute;"), (oe || c || !ie) && (m += (t === fe ? Vr : Xr) + ":" + (a + parseFloat(d)) + "px;"), l && (m += "box-sizing:border-box;text-align:left;width:" + l.offsetWidth + "px;"), w._isStart = H, w.setAttribute("class", "gsap-marker-" + e + (n ? " marker-" + n : "")), w.style.cssText = m, w.innerText = n || n === 0 ? e + "-" + n : e, he.children[0] ? he.insertBefore(w, he.children[0]) : he.appendChild(w), w._offset = w["offset" + t.op.d2], ur(w, 0, t, H), w;
}, ur = function(e, n, r, t) {
  var o = {
    display: "block"
  }, a = r[t ? "os2" : "p2"], l = r[t ? "p2" : "os2"];
  e._isFlipped = t, o[r.a + "Percent"] = t ? -100 : 0, o[r.a] = t ? "1px" : 0, o["border" + a + yt] = 1, o["border" + l + yt] = 0, o[r.p] = n + "px", u.set(e, o);
}, b = [], Lr = {}, Ht, un = function() {
  return ue() - Ae > 34 && (Ht || (Ht = requestAnimationFrame(Ke)));
}, _t = function() {
  (!xe || !xe.isPressed || xe.startX > M.clientWidth) && (A.cache++, xe ? Ht || (Ht = requestAnimationFrame(Ke)) : Ke(), Ae || ct("scrollStart"), Ae = ue());
}, Dr = function() {
  yn = y.innerWidth, Cn = y.innerHeight;
}, Dt = function() {
  A.cache++, !ne && !bn && !F.fullscreenElement && !F.webkitFullscreenElement && (!xn || yn !== y.innerWidth || Math.abs(y.innerHeight - Cn) > y.innerHeight * 0.25) && hr.restart(!0);
}, ut = {}, qn = [], An = function s() {
  return V(S, "scrollEnd", s) || it(!0);
}, ct = function(e) {
  return ut[e] && ut[e].map(function(n) {
    return n();
  }) || qn;
}, Ce = [], On = function(e) {
  for (var n = 0; n < Ce.length; n += 5)
    (!e || Ce[n + 4] && Ce[n + 4].query === e) && (Ce[n].style.cssText = Ce[n + 1], Ce[n].getBBox && Ce[n].setAttribute("transform", Ce[n + 2] || ""), Ce[n + 3].uncache = 1);
}, Kr = function(e, n) {
  var r;
  for (le = 0; le < b.length; le++)
    r = b[le], r && (!n || r._ctx === n) && (e ? r.kill(1) : r.revert(!0, !0));
  n && On(n), n || ct("revert");
}, Dn = function(e, n) {
  A.cache++, (n || !ae) && A.forEach(function(r) {
    return ce(r) && r.cacheID++ && (r.rec = 0);
  }), ye(e) && (y.history.scrollRestoration = Yr = e);
}, ae, at = 0, cn, Gn = function() {
  if (cn !== at) {
    var e = cn = at;
    requestAnimationFrame(function() {
      return e === at && it(!0);
    });
  }
}, zn = function() {
  M.appendChild(bt), Ur = bt.offsetHeight || y.innerHeight, M.removeChild(bt);
}, it = function(e, n) {
  if (Ae && !e) {
    X(S, "scrollEnd", An);
    return;
  }
  zn(), ae = S.isRefreshing = !0, A.forEach(function(t) {
    return ce(t) && ++t.cacheID && (t.rec = t());
  });
  var r = ct("refreshInit");
  mn && S.sort(), n || Kr(), A.forEach(function(t) {
    ce(t) && (t.smooth && (t.target.style.scrollBehavior = "auto"), t(0));
  }), b.slice(0).forEach(function(t) {
    return t.refresh();
  }), b.forEach(function(t, o) {
    if (t._subPinOffset && t.pin) {
      var a = t.vars.horizontal ? "offsetWidth" : "offsetHeight", l = t.pin[a];
      t.revert(!0, 1), t.adjustPinSpacing(t.pin[a] - l), t.refresh();
    }
  }), b.forEach(function(t) {
    var o = Ge(t.scroller, t._dir);
    (t.vars.end === "max" || t._endClamp && t.end > o) && t.setPositions(t.start, Math.max(t.start + 1, o), !0);
  }), r.forEach(function(t) {
    return t && t.render && t.render(-1);
  }), A.forEach(function(t) {
    ce(t) && (t.smooth && requestAnimationFrame(function() {
      return t.target.style.scrollBehavior = "smooth";
    }), t.rec && t(t.rec));
  }), Dn(Yr, 1), hr.pause(), at++, ae = 2, Ke(2), b.forEach(function(t) {
    return ce(t.vars.onRefresh) && t.vars.onRefresh(t);
  }), ae = S.isRefreshing = !1, ct("refresh");
}, Hr = 0, cr = 1, Lt, Ke = function(e) {
  if (!ae || e === 2) {
    S.isUpdating = !0, Lt && Lt.update(0);
    var n = b.length, r = ue(), t = r - Ar >= 50, o = n && b[0].scroll();
    if (cr = Hr > o ? -1 : 1, ae || (Hr = o), t && (Ae && !vr && r - Ae > 200 && (Ae = 0, ct("scrollEnd")), lr = Ar, Ar = r), cr < 0) {
      for (le = n; le-- > 0; )
        b[le] && b[le].update(0, t);
      cr = 1;
    } else
      for (le = 0; le < n; le++)
        b[le] && b[le].update(0, t);
    S.isUpdating = !1;
  }
  Ht = 0;
}, Wr = [Pn, En, Xr, Vr, Ee + Bt, Ee + It, Ee + Nt, Ee + Ft, "display", "flexShrink", "float", "zIndex", "gridColumnStart", "gridColumnEnd", "gridRowStart", "gridRowEnd", "gridArea", "justifySelf", "alignSelf", "placeSelf", "order"], pr = Wr.concat([st, lt, "boxSizing", "max" + yt, "max" + qr, "position", Ee, W, W + Nt, W + It, W + Bt, W + Ft]), Kn = function(e, n, r) {
  xt(r);
  var t = e._gsap;
  if (t.spacerIsNative)
    xt(t.spacerState);
  else if (e._gsap.swappedIn) {
    var o = n.parentNode;
    o && (o.insertBefore(e, n), o.removeChild(n));
  }
  e._gsap.swappedIn = !1;
}, zr = function(e, n, r, t) {
  if (!e._gsap.swappedIn) {
    for (var o = Wr.length, a = n.style, l = e.style, c; o--; )
      c = Wr[o], a[c] = r[c];
    a.position = r.position === "absolute" ? "absolute" : "relative", r.display === "inline" && (a.display = "inline-block"), l[Xr] = l[Vr] = "auto", a.flexBasis = r.flexBasis || "auto", a.overflow = "visible", a.boxSizing = "border-box", a[st] = Br(e, Fe) + J, a[lt] = Br(e, fe) + J, a[W] = l[Ee] = l[En] = l[Pn] = "0", xt(t), l[st] = l["max" + yt] = r[st], l[lt] = l["max" + qr] = r[lt], l[W] = r[W], e.parentNode !== n && (e.parentNode.insertBefore(n, e), n.appendChild(e)), e._gsap.swappedIn = !0;
  }
}, $n = /([A-Z])/g, xt = function(e) {
  if (e) {
    var n = e.t.style, r = e.length, t = 0, o, a;
    for ((e.t._gsap || u.core.getCache(e.t)).uncache = 1; t < r; t += 2)
      a = e[t + 1], o = e[t], a ? n[o] = a : n[o] && n.removeProperty(o.replace($n, "-$1").toLowerCase());
  }
}, ir = function(e) {
  for (var n = pr.length, r = e.style, t = [], o = 0; o < n; o++)
    t.push(pr[o], r[pr[o]]);
  return t.t = e, t;
}, Jn = function(e, n, r) {
  for (var t = [], o = e.length, a = r ? 8 : 0, l; a < o; a += 2)
    l = e[a], t.push(l, l in n ? n[l] : e[a + 1]);
  return t.t = e.t, t;
}, dr = {
  left: 0,
  top: 0
}, pn = function(e, n, r, t, o, a, l, c, C, L, O, d, f, w) {
  ce(e) && (e = e(c)), ye(e) && e.substr(0, 3) === "max" && (e = d + (e.charAt(4) === "=" ? fr("0" + e.substr(3), r) : 0));
  var ie = f ? f.time() : 0, oe, he, H;
  if (f && f.seek(0), isNaN(e) || (e = +e), ar(e))
    f && (e = u.utils.mapRange(f.scrollTrigger.start, f.scrollTrigger.end, 0, d, e)), l && ur(l, r, t, !0);
  else {
    ce(n) && (n = n(c));
    var pe = (e || "0").split(" "), m, Ue, N, _;
    H = be(n, c) || M, m = qe(H) || {}, (!m || !m.left && !m.top) && Me(H).display === "none" && (_ = H.style.display, H.style.display = "block", m = qe(H), _ ? H.style.display = _ : H.style.removeProperty("display")), Ue = fr(pe[0], m[t.d]), N = fr(pe[1] || "0", r), e = m[t.p] - C[t.p] - L + Ue + o - N, l && ur(l, N, t, r - N < 20 || l._isStart && N > 20), r -= r - N;
  }
  if (w && (c[w] = e || -1e-3, e < 0 && (e = 0)), a) {
    var Se = e + r, Oe = a._isStart;
    oe = "scroll" + t.d2, ur(a, Se, t, Oe && Se > 20 || !Oe && (O ? Math.max(M[oe], Ie[oe]) : a.parentNode[oe]) <= Se + 1), O && (C = qe(l), O && (a.style[t.op.p] = C[t.op.p] - t.op.m - a._offset + J));
  }
  return f && H && (oe = qe(H), f.seek(d), he = qe(H), f._caScrollDist = oe[t.p] - he[t.p], e = e / f._caScrollDist * d), f && f.seek(ie), f ? e : Math.round(e);
}, Qn = /(webkit|moz|length|cssText|inset)/i, dn = function(e, n, r, t) {
  if (e.parentNode !== n) {
    var o = e.style, a, l;
    if (n === M) {
      e._stOrig = o.cssText, l = Me(e);
      for (a in l)
        !+a && !Qn.test(a) && l[a] && typeof o[a] == "string" && a !== "0" && (o[a] = l[a]);
      o.top = r, o.left = t;
    } else
      o.cssText = e._stOrig;
    u.core.getCache(e).uncache = 1, n.appendChild(e);
  }
}, In = function(e, n, r) {
  var t = n, o = t;
  return function(a) {
    var l = Math.round(e());
    return l !== t && l !== o && Math.abs(l - t) > 3 && Math.abs(l - o) > 3 && (a = l, r && r()), o = t, t = a, a;
  };
}, or = function(e, n, r) {
  var t = {};
  t[n.p] = "+=" + r, u.set(e, t);
}, hn = function(e, n) {
  var r = Ct(e, n), t = "_scroll" + n.p2, o = function a(l, c, C, L, O) {
    var d = a.tween, f = c.onComplete, w = {};
    C = C || r();
    var ie = In(r, C, function() {
      d.kill(), a.tween = 0;
    });
    return O = L && O || 0, L = L || l - C, d && d.kill(), c[t] = l, c.modifiers = w, w[t] = function() {
      return ie(C + L * d.ratio + O * d.ratio * d.ratio);
    }, c.onUpdate = function() {
      A.cache++, Ke();
    }, c.onComplete = function() {
      a.tween = 0, f && f.call(d);
    }, d = a.tween = u.to(e, c), d;
  };
  return e[t] = r, r.wheelHandler = function() {
    return o.tween && o.tween.kill() && (o.tween = 0);
  }, X(e, "wheel", r.wheelHandler), S.isTouch && X(e, "touchmove", r.wheelHandler), o;
}, S = /* @__PURE__ */ (function() {
  function s(n, r) {
    vt || s.register(u) || console.warn("Please gsap.registerPlugin(ScrollTrigger)"), Nr(this), this.init(n, r);
  }
  var e = s.prototype;
  return e.init = function(r, t) {
    if (this.progress = this.start = 0, this.vars && this.kill(!0, !0), !At) {
      this.update = this.refresh = this.kill = Ye;
      return;
    }
    r = an(ye(r) || ar(r) || r.nodeType ? {
      trigger: r
    } : r, rr);
    var o = r, a = o.onUpdate, l = o.toggleClass, c = o.id, C = o.onToggle, L = o.onRefresh, O = o.scrub, d = o.trigger, f = o.pin, w = o.pinSpacing, ie = o.invalidateOnRefresh, oe = o.anticipatePin, he = o.onScrubComplete, H = o.onSnapComplete, pe = o.once, m = o.snap, Ue = o.pinReparent, N = o.pinSpacer, _ = o.containerAnimation, Se = o.fastScrollEnd, Oe = o.preventOverlaps, h = r.horizontal || r.containerAnimation && r.horizontal !== !1 ? Fe : fe, de = !O && O !== 0, v = be(r.scroller || y), pt = u.core.getCache(v), Q = ft(v), Te = ("pinType" in r ? r.pinType : ot(v, "pinType") || Q && "fixed") === "fixed", De = [r.onEnter, r.onLeave, r.onEnterBack, r.onLeaveBack], D = de && r.toggleActions.split(" "), ge = "markers" in r ? r.markers : rr.markers, q = Q ? 0 : parseFloat(Me(v)["border" + h.p2 + yt]) || 0, i = this, Z = r.onRefreshInit && function() {
      return r.onRefreshInit(i);
    }, Wt = Wn(v, Q, h), St = Yn(v, Q), Ve = 0, Yt = 0, $e = 0, G = Ct(v, h), _e, ve, $r, et, Tt, P, j, Be, tt, ke, Xe, kt, wr, ee, Ut, Vt, mr, Re, br, xr, Cr, Xt, dt, Jr, Pe, Qr, yr, Sr, Tr, qt, kr, k, Gt, Je, Qe, Ze, Kt, Rr, ht;
    if (i._startClamp = i._endClamp = !1, i._dir = h, oe *= 45, i.scroller = v, i.scroll = _ ? _.time.bind(_) : G, et = G(), i.vars = r, t = t || r.animation, "refreshPriority" in r && (mn = 1, r.refreshPriority === -9999 && (Lt = i)), pt.tweenScroll = pt.tweenScroll || {
      top: hn(v, fe),
      left: hn(v, Fe)
    }, i.tweenTo = _e = pt.tweenScroll[h.p], i.scrubDuration = function(p) {
      Gt = ar(p) && p, Gt ? k ? k.duration(p) : k = u.to(t, {
        ease: "expo",
        totalProgress: "+=0",
        duration: Gt,
        paused: !0,
        onComplete: function() {
          return he && he(i);
        }
      }) : (k && k.progress(1).kill(), k = 0);
    }, t && (t.vars.lazy = !1, t._initted && !i.isReverted || t.vars.immediateRender !== !1 && r.immediateRender !== !1 && t.duration() && t.render(0, !0, !0), i.animation = t.pause(), t.scrollTrigger = i, i.scrubDuration(O), qt = 0, c || (c = t.vars.id)), m && ((!nt(m) || m.push) && (m = {
      snapTo: m
    }), "scrollBehavior" in M.style && u.set(Q ? [M, Ie] : v, {
      scrollBehavior: "auto"
    }), A.forEach(function(p) {
      return ce(p) && p.target === (Q ? F.scrollingElement || Ie : v) && (p.smooth = !1);
    }), $r = ce(m.snapTo) ? m.snapTo : m.snapTo === "labels" ? Vn(t) : m.snapTo === "labelsDirectional" ? Xn(t) : m.directional !== !1 ? function(p, R) {
      return Gr(m.snapTo)(p, ue() - Yt < 500 ? 0 : R.direction);
    } : u.utils.snap(m.snapTo), Je = m.duration || {
      min: 0.1,
      max: 2
    }, Je = nt(Je) ? mt(Je.min, Je.max) : mt(Je, Je), Qe = u.delayedCall(m.delay || Gt / 2 || 0.1, function() {
      var p = G(), R = ue() - Yt < 500, g = _e.tween;
      if ((R || Math.abs(i.getVelocity()) < 10) && !g && !vr && Ve !== p) {
        var x = (p - P) / ee, U = t && !de ? t.totalProgress() : x, T = R ? 0 : (U - kr) / (ue() - lr) * 1e3 || 0, B = u.utils.clamp(-x, 1 - x, gt(T / 2) * T / 0.185), se = x + (m.inertia === !1 ? 0 : B), K = mt(0, 1, $r(se, i)), z = Math.round(P + K * ee), E = m, ze = E.onStart, I = E.onInterrupt, we = E.onComplete;
        if (p <= j && p >= P && z !== p) {
          if (g && !g._initted && g.data <= gt(z - p))
            return;
          m.inertia === !1 && (B = K - x), _e(z, {
            duration: Je(gt(Math.max(gt(se - U), gt(K - U)) * 0.185 / T / 0.05 || 0)),
            ease: m.ease || "power3",
            data: gt(z - p),
            // record the distance so that if another snap tween occurs (conflict) we can prioritize the closest snap.
            onInterrupt: function() {
              return Qe.restart(!0) && I && I(i);
            },
            onComplete: function() {
              i.update(), Ve = G(), qt = kr = t && !de ? t.totalProgress() : i.progress, H && H(i), we && we(i);
            }
          }, p, B * ee, z - p - B * ee), ze && ze(i, _e.tween);
        }
      } else i.isActive && Ve !== p && Qe.restart(!0);
    }).pause()), c && (Lr[c] = i), d = i.trigger = be(d || f !== !0 && f), ht = d && d._gsap && d._gsap.stRevert, ht && (ht = ht(i)), f = f === !0 ? d : be(f), ye(l) && (l = {
      targets: d,
      className: l
    }), f && (w === !1 || w === Ee || (w = !w && f.parentNode && f.parentNode.style && Me(f.parentNode).display === "flex" ? !1 : W), i.pin = f, ve = u.core.getCache(f), ve.spacer ? Ut = ve.pinState : (N && (N = be(N), N && !N.nodeType && (N = N.current || N.nativeElement), ve.spacerIsNative = !!N, N && (ve.spacerState = ir(N))), ve.spacer = Re = N || F.createElement("div"), Re.classList.add("pin-spacer"), c && Re.classList.add("pin-spacer-" + c), ve.pinState = Ut = ir(f)), r.force3D !== !1 && u.set(f, {
      force3D: !0
    }), i.spacer = Re = ve.spacer, Tr = Me(f), Jr = Tr[w + h.os2], xr = u.getProperty(f), Cr = u.quickSetter(f, h.a, J), zr(f, Re, Tr), mr = ir(f)), ge) {
      kt = nt(ge) ? an(ge, fn) : fn, ke = nr("scroller-start", c, v, h, kt, 0), Xe = nr("scroller-end", c, v, h, kt, 0, ke), br = ke["offset" + h.op.d2];
      var Zr = be(ot(v, "content") || v);
      Be = this.markerStart = nr("start", c, Zr, h, kt, br, 0, _), tt = this.markerEnd = nr("end", c, Zr, h, kt, br, 0, _), _ && (Rr = u.quickSetter([Be, tt], h.a, J)), !Te && !(zt.length && ot(v, "fixedMarkers") === !0) && (Un(Q ? M : v), u.set([ke, Xe], {
        force3D: !0
      }), Qr = u.quickSetter(ke, h.a, J), Sr = u.quickSetter(Xe, h.a, J));
    }
    if (_) {
      var jr = _.vars.onUpdate, Nn = _.vars.onUpdateParams;
      _.eventCallback("onUpdate", function() {
        i.update(0, 0, 1), jr && jr.apply(_, Nn || []);
      });
    }
    if (i.previous = function() {
      return b[b.indexOf(i) - 1];
    }, i.next = function() {
      return b[b.indexOf(i) + 1];
    }, i.revert = function(p, R) {
      if (!R)
        return i.kill(!0);
      var g = p !== !1 || !i.enabled, x = ne;
      g !== i.isReverted && (g && (Ze = Math.max(G(), i.scroll.rec || 0), $e = i.progress, Kt = t && t.progress()), Be && [Be, tt, ke, Xe].forEach(function(U) {
        return U.style.display = g ? "none" : "block";
      }), g && (ne = i, i.update(g)), f && (!Ue || !i.isActive) && (g ? Kn(f, Re, Ut) : zr(f, Re, Me(f), Pe)), g || i.update(g), ne = x, i.isReverted = g);
    }, i.refresh = function(p, R, g, x) {
      if (!((ne || !i.enabled) && !R)) {
        if (f && p && Ae) {
          X(s, "scrollEnd", An);
          return;
        }
        !ae && Z && Z(i), ne = i, _e.tween && !g && (_e.tween.kill(), _e.tween = 0), k && k.pause(), ie && t && t.revert({
          kill: !1
        }).invalidate(), i.isReverted || i.revert(!0, !0), i._subPinOffset = !1;
        var U = Wt(), T = St(), B = _ ? _.duration() : Ge(v, h), se = ee <= 0.01, K = 0, z = x || 0, E = nt(g) ? g.end : r.end, ze = r.endTrigger || d, I = nt(g) ? g.start : r.start || (r.start === 0 || !d ? 0 : f ? "0 0" : "0 100%"), we = i.pinnedContainer = r.pinnedContainer && be(r.pinnedContainer, i), Le = d && Math.max(0, b.indexOf(i)) || 0, me = Le, $, te, rt, $t, re, Y, He, Pr, en, Rt, We, Pt, Jt;
        for (ge && nt(g) && (Pt = u.getProperty(ke, h.p), Jt = u.getProperty(Xe, h.p)); me--; )
          Y = b[me], Y.end || Y.refresh(0, 1) || (ne = i), He = Y.pin, He && (He === d || He === f || He === we) && !Y.isReverted && (Rt || (Rt = []), Rt.unshift(Y), Y.revert(!0, !0)), Y !== b[me] && (Le--, me--);
        for (ce(I) && (I = I(i)), I = nn(I, "start", i), P = pn(I, d, U, h, G(), Be, ke, i, T, q, Te, B, _, i._startClamp && "_startClamp") || (f ? -1e-3 : 0), ce(E) && (E = E(i)), ye(E) && !E.indexOf("+=") && (~E.indexOf(" ") ? E = (ye(I) ? I.split(" ")[0] : "") + E : (K = fr(E.substr(2), U), E = ye(I) ? I : (_ ? u.utils.mapRange(0, _.duration(), _.scrollTrigger.start, _.scrollTrigger.end, P) : P) + K, ze = d)), E = nn(E, "end", i), j = Math.max(P, pn(E || (ze ? "100% 0" : B), ze, U, h, G() + K, tt, Xe, i, T, q, Te, B, _, i._endClamp && "_endClamp")) || -1e-3, K = 0, me = Le; me--; )
          Y = b[me], He = Y.pin, He && Y.start - Y._pinPush <= P && !_ && Y.end > 0 && ($ = Y.end - (i._startClamp ? Math.max(0, Y.start) : Y.start), (He === d && Y.start - Y._pinPush < P || He === we) && isNaN(I) && (K += $ * (1 - Y.progress)), He === f && (z += $));
        if (P += K, j += K, i._startClamp && (i._startClamp += K), i._endClamp && !ae && (i._endClamp = j || -1e-3, j = Math.min(j, Ge(v, h))), ee = j - P || (P -= 0.01) && 1e-3, se && ($e = u.utils.clamp(0, 1, u.utils.normalize(P, j, Ze))), i._pinPush = z, Be && K && ($ = {}, $[h.a] = "+=" + K, we && ($[h.p] = "-=" + G()), u.set([Be, tt], $)), f)
          $ = Me(f), $t = h === fe, rt = G(), Xt = parseFloat(xr(h.a)) + z, !B && j > 1 && (We = (Q ? F.scrollingElement || Ie : v).style, We = {
            style: We,
            value: We["overflow" + h.a.toUpperCase()]
          }, Q && Me(M)["overflow" + h.a.toUpperCase()] !== "scroll" && (We.style["overflow" + h.a.toUpperCase()] = "scroll")), zr(f, Re, $), mr = ir(f), te = qe(f, !0), Pr = Te && Ct(v, $t ? Fe : fe)(), w && (Pe = [w + h.os2, ee + z + J], Pe.t = Re, me = w === W ? Br(f, h) + ee + z : 0, me && Pe.push(h.d, me + J), xt(Pe), we && b.forEach(function(Et) {
            Et.pin === we && Et.vars.pinSpacing !== !1 && (Et._subPinOffset = !0);
          }), Te && G(Ze)), Te && (re = {
            top: te.top + ($t ? rt - P : Pr) + J,
            left: te.left + ($t ? Pr : rt - P) + J,
            boxSizing: "border-box",
            position: "fixed"
          }, re[st] = re["max" + yt] = Math.ceil(te.width) + J, re[lt] = re["max" + qr] = Math.ceil(te.height) + J, re[Ee] = re[Ee + Nt] = re[Ee + It] = re[Ee + Bt] = re[Ee + Ft] = "0", re[W] = $[W], re[W + Nt] = $[W + Nt], re[W + It] = $[W + It], re[W + Bt] = $[W + Bt], re[W + Ft] = $[W + Ft], Vt = Jn(Ut, re, Ue), ae && G(0)), t ? (en = t._initted, Er(1), t.render(t.duration(), !0, !0), dt = xr(h.a) - Xt + ee + z, yr = Math.abs(ee - dt) > 1, Te && yr && Vt.splice(Vt.length - 2, 2), t.render(0, !0, !0), en || t.invalidate(!0), t.parent || t.totalTime(t.totalTime()), Er(0)) : dt = ee, We && (We.value ? We.style["overflow" + h.a.toUpperCase()] = We.value : We.style.removeProperty("overflow-" + h.a));
        else if (d && G() && !_)
          for (te = d.parentNode; te && te !== M; )
            te._pinOffset && (P -= te._pinOffset, j -= te._pinOffset), te = te.parentNode;
        Rt && Rt.forEach(function(Et) {
          return Et.revert(!1, !0);
        }), i.start = P, i.end = j, et = Tt = ae ? Ze : G(), !_ && !ae && (et < Ze && G(Ze), i.scroll.rec = 0), i.revert(!1, !0), Yt = ue(), Qe && (Ve = -1, Qe.restart(!0)), ne = 0, t && de && (t._initted || Kt) && t.progress() !== Kt && t.progress(Kt || 0, !0).render(t.time(), !0, !0), (se || $e !== i.progress || _) && (t && !de && t.totalProgress(_ && P < -1e-3 && !$e ? u.utils.normalize(P, j, 0) : $e, !0), i.progress = se || (et - P) / ee === $e ? 0 : $e), f && w && (Re._pinOffset = Math.round(i.progress * dt)), k && k.invalidate(), isNaN(Pt) || (Pt -= u.getProperty(ke, h.p), Jt -= u.getProperty(Xe, h.p), or(ke, h, Pt), or(Be, h, Pt - (x || 0)), or(Xe, h, Jt), or(tt, h, Jt - (x || 0))), se && !ae && i.update(), L && !ae && !wr && (wr = !0, L(i), wr = !1);
      }
    }, i.getVelocity = function() {
      return (G() - Tt) / (ue() - lr) * 1e3 || 0;
    }, i.endAnimation = function() {
      Mt(i.callbackAnimation), t && (k ? k.progress(1) : t.paused() ? de || Mt(t, i.direction < 0, 1) : Mt(t, t.reversed()));
    }, i.labelToScroll = function(p) {
      return t && t.labels && (P || i.refresh() || P) + t.labels[p] / t.duration() * ee || 0;
    }, i.getTrailing = function(p) {
      var R = b.indexOf(i), g = i.direction > 0 ? b.slice(0, R).reverse() : b.slice(R + 1);
      return (ye(p) ? g.filter(function(x) {
        return x.vars.preventOverlaps === p;
      }) : g).filter(function(x) {
        return i.direction > 0 ? x.end <= P : x.start >= j;
      });
    }, i.update = function(p, R, g) {
      if (!(_ && !g && !p)) {
        var x = ae === !0 ? Ze : i.scroll(), U = p ? 0 : (x - P) / ee, T = U < 0 ? 0 : U > 1 ? 1 : U || 0, B = i.progress, se, K, z, E, ze, I, we, Le;
        if (R && (Tt = et, et = _ ? G() : x, m && (kr = qt, qt = t && !de ? t.totalProgress() : T)), oe && !T && f && !ne && !Zt && Ae && P < x + (x - Tt) / (ue() - lr) * oe && (T = 1e-4), T !== B && i.enabled) {
          if (se = i.isActive = !!T && T < 1, K = !!B && B < 1, I = se !== K, ze = I || !!T != !!B, i.direction = T > B ? 1 : -1, i.progress = T, ze && !ne && (z = T && !B ? 0 : T === 1 ? 1 : B === 1 ? 2 : 3, de && (E = !I && D[z + 1] !== "none" && D[z + 1] || D[z], Le = t && (E === "complete" || E === "reset" || E in t))), Oe && (I || Le) && (Le || O || !t) && (ce(Oe) ? Oe(i) : i.getTrailing(Oe).forEach(function(rt) {
            return rt.endAnimation();
          })), de || (k && !ne && !Zt ? (k._dp._time - k._start !== k._time && k.render(k._dp._time - k._start), k.resetTo ? k.resetTo("totalProgress", T, t._tTime / t._tDur) : (k.vars.totalProgress = T, k.invalidate().restart())) : t && t.totalProgress(T, !!(ne && (Yt || p)))), f) {
            if (p && w && (Re.style[w + h.os2] = Jr), !Te)
              Cr(Ot(Xt + dt * T));
            else if (ze) {
              if (we = !p && T > B && j + 1 > x && x + 1 >= Ge(v, h), Ue)
                if (!p && (se || we)) {
                  var me = qe(f, !0), $ = x - P;
                  dn(f, M, me.top + (h === fe ? $ : 0) + J, me.left + (h === fe ? 0 : $) + J);
                } else
                  dn(f, Re);
              xt(se || we ? Vt : mr), yr && T < 1 && se || Cr(Xt + (T === 1 && !we ? dt : 0));
            }
          }
          m && !_e.tween && !ne && !Zt && Qe.restart(!0), l && (I || pe && T && (T < 1 || !Mr)) && gr(l.targets).forEach(function(rt) {
            return rt.classList[se || pe ? "add" : "remove"](l.className);
          }), a && !de && !p && a(i), ze && !ne ? (de && (Le && (E === "complete" ? t.pause().totalProgress(1) : E === "reset" ? t.restart(!0).pause() : E === "restart" ? t.restart(!0) : t[E]()), a && a(i)), (I || !Mr) && (C && I && Or(i, C), De[z] && Or(i, De[z]), pe && (T === 1 ? i.kill(!1, 1) : De[z] = 0), I || (z = T === 1 ? 1 : 3, De[z] && Or(i, De[z]))), Se && !se && Math.abs(i.getVelocity()) > (ar(Se) ? Se : 2500) && (Mt(i.callbackAnimation), k ? k.progress(1) : Mt(t, E === "reverse" ? 1 : !T, 1))) : de && a && !ne && a(i);
        }
        if (Sr) {
          var te = _ ? x / _.duration() * (_._caScrollDist || 0) : x;
          Qr(te + (ke._isFlipped ? 1 : 0)), Sr(te);
        }
        Rr && Rr(-x / _.duration() * (_._caScrollDist || 0));
      }
    }, i.enable = function(p, R) {
      i.enabled || (i.enabled = !0, X(v, "resize", Dt), Q || X(v, "scroll", _t), Z && X(s, "refreshInit", Z), p !== !1 && (i.progress = $e = 0, et = Tt = Ve = G()), R !== !1 && i.refresh());
    }, i.getTween = function(p) {
      return p && _e ? _e.tween : k;
    }, i.setPositions = function(p, R, g, x) {
      if (_) {
        var U = _.scrollTrigger, T = _.duration(), B = U.end - U.start;
        p = U.start + B * p / T, R = U.start + B * R / T;
      }
      i.refresh(!1, !1, {
        start: on(p, g && !!i._startClamp),
        end: on(R, g && !!i._endClamp)
      }, x), i.update();
    }, i.adjustPinSpacing = function(p) {
      if (Pe && p) {
        var R = Pe.indexOf(h.d) + 1;
        Pe[R] = parseFloat(Pe[R]) + p + J, Pe[1] = parseFloat(Pe[1]) + p + J, xt(Pe);
      }
    }, i.disable = function(p, R) {
      if (i.enabled && (p !== !1 && i.revert(!0, !0), i.enabled = i.isActive = !1, R || k && k.pause(), Ze = 0, ve && (ve.uncache = 1), Z && V(s, "refreshInit", Z), Qe && (Qe.pause(), _e.tween && _e.tween.kill() && (_e.tween = 0)), !Q)) {
        for (var g = b.length; g--; )
          if (b[g].scroller === v && b[g] !== i)
            return;
        V(v, "resize", Dt), Q || V(v, "scroll", _t);
      }
    }, i.kill = function(p, R) {
      i.disable(p, R), k && !R && k.kill(), c && delete Lr[c];
      var g = b.indexOf(i);
      g >= 0 && b.splice(g, 1), g === le && cr > 0 && le--, g = 0, b.forEach(function(x) {
        return x.scroller === i.scroller && (g = 1);
      }), g || ae || (i.scroll.rec = 0), t && (t.scrollTrigger = null, p && t.revert({
        kill: !1
      }), R || t.kill()), Be && [Be, tt, ke, Xe].forEach(function(x) {
        return x.parentNode && x.parentNode.removeChild(x);
      }), Lt === i && (Lt = 0), f && (ve && (ve.uncache = 1), g = 0, b.forEach(function(x) {
        return x.pin === f && g++;
      }), g || (ve.spacer = 0)), r.onKill && r.onKill(i);
    }, b.push(i), i.enable(!1, !1), ht && ht(i), t && t.add && !ee) {
      var Bn = i.update;
      i.update = function() {
        i.update = Bn, P || j || i.refresh();
      }, u.delayedCall(0.01, i.update), ee = 0.01, P = j = 0;
    } else
      i.refresh();
    f && Gn();
  }, s.register = function(r) {
    return vt || (u = r || Tn(), Sn() && window.document && s.enable(), vt = At), vt;
  }, s.defaults = function(r) {
    if (r)
      for (var t in r)
        rr[t] = r[t];
    return rr;
  }, s.disable = function(r, t) {
    At = 0, b.forEach(function(a) {
      return a[t ? "kill" : "disable"](r);
    }), V(y, "wheel", _t), V(F, "scroll", _t), clearInterval(Qt), V(F, "touchcancel", Ye), V(M, "touchstart", Ye), er(V, F, "pointerdown,touchstart,mousedown", sn), er(V, F, "pointerup,touchend,mouseup", ln), hr.kill(), jt(V);
    for (var o = 0; o < A.length; o += 3)
      tr(V, A[o], A[o + 1]), tr(V, A[o], A[o + 2]);
  }, s.enable = function() {
    if (y = window, F = document, Ie = F.documentElement, M = F.body, u && (gr = u.utils.toArray, mt = u.utils.clamp, Nr = u.core.context || Ye, Er = u.core.suppressOverwrites || Ye, Yr = y.history.scrollRestoration || "auto", Hr = y.pageYOffset, u.core.globals("ScrollTrigger", s), M)) {
      At = 1, bt = document.createElement("div"), bt.style.height = "100vh", bt.style.position = "absolute", zn(), Hn(), Ne.register(u), s.isTouch = Ne.isTouch, je = Ne.isTouch && /(iPad|iPhone|iPod|Mac)/g.test(navigator.userAgent), X(y, "wheel", _t), wn = [y, F, Ie, M], u.matchMedia ? (s.matchMedia = function(c) {
        var C = u.matchMedia(), L;
        for (L in c)
          C.add(L, c[L]);
        return C;
      }, u.addEventListener("matchMediaInit", function() {
        return Kr();
      }), u.addEventListener("matchMediaRevert", function() {
        return On();
      }), u.addEventListener("matchMedia", function() {
        it(0, 1), ct("matchMedia");
      }), u.matchMedia("(orientation: portrait)", function() {
        return Dr(), Dr;
      })) : console.warn("Requires GSAP 3.11.0 or later"), Dr(), X(F, "scroll", _t);
      var r = M.style, t = r.borderTopStyle, o = u.core.Animation.prototype, a, l;
      for (o.revert || Object.defineProperty(o, "revert", {
        value: function() {
          return this.time(-0.01, !0);
        }
      }), r.borderTopStyle = "solid", a = qe(M), fe.m = Math.round(a.top + fe.sc()) || 0, Fe.m = Math.round(a.left + Fe.sc()) || 0, t ? r.borderTopStyle = t : r.removeProperty("border-top-style"), Qt = setInterval(un, 250), u.delayedCall(0.5, function() {
        return Zt = 0;
      }), X(F, "touchcancel", Ye), X(M, "touchstart", Ye), er(X, F, "pointerdown,touchstart,mousedown", sn), er(X, F, "pointerup,touchend,mouseup", ln), Fr = u.utils.checkPrefix("transform"), pr.push(Fr), vt = ue(), hr = u.delayedCall(0.2, it).pause(), wt = [F, "visibilitychange", function() {
        var c = y.innerWidth, C = y.innerHeight;
        F.hidden ? (tn = c, rn = C) : (tn !== c || rn !== C) && Dt();
      }, F, "DOMContentLoaded", it, y, "load", it, y, "resize", Dt], jt(X), b.forEach(function(c) {
        return c.enable(0, 1);
      }), l = 0; l < A.length; l += 3)
        tr(V, A[l], A[l + 1]), tr(V, A[l], A[l + 2]);
    }
  }, s.config = function(r) {
    "limitCallbacks" in r && (Mr = !!r.limitCallbacks);
    var t = r.syncInterval;
    t && clearInterval(Qt) || (Qt = t) && setInterval(un, t), "ignoreMobileResize" in r && (xn = s.isTouch === 1 && r.ignoreMobileResize), "autoRefreshEvents" in r && (jt(V) || jt(X, r.autoRefreshEvents || "none"), bn = (r.autoRefreshEvents + "").indexOf("resize") === -1);
  }, s.scrollerProxy = function(r, t) {
    var o = be(r), a = A.indexOf(o), l = ft(o);
    ~a && A.splice(a, l ? 6 : 2), t && (l ? zt.unshift(y, t, M, t, Ie, t) : zt.unshift(o, t));
  }, s.clearMatchMedia = function(r) {
    b.forEach(function(t) {
      return t._ctx && t._ctx.query === r && t._ctx.kill(!0, !0);
    });
  }, s.isInViewport = function(r, t, o) {
    var a = (ye(r) ? be(r) : r).getBoundingClientRect(), l = a[o ? st : lt] * t || 0;
    return o ? a.right - l > 0 && a.left + l < y.innerWidth : a.bottom - l > 0 && a.top + l < y.innerHeight;
  }, s.positionInViewport = function(r, t, o) {
    ye(r) && (r = be(r));
    var a = r.getBoundingClientRect(), l = a[o ? st : lt], c = t == null ? l / 2 : t in _r ? _r[t] * l : ~t.indexOf("%") ? parseFloat(t) * l / 100 : parseFloat(t) || 0;
    return o ? (a.left + c) / y.innerWidth : (a.top + c) / y.innerHeight;
  }, s.killAll = function(r) {
    if (b.slice(0).forEach(function(o) {
      return o.vars.id !== "ScrollSmoother" && o.kill();
    }), r !== !0) {
      var t = ut.killAll || [];
      ut = {}, t.forEach(function(o) {
        return o();
      });
    }
  }, s;
})();
S.version = "3.12.2";
S.saveStyles = function(s) {
  return s ? gr(s).forEach(function(e) {
    if (e && e.style) {
      var n = Ce.indexOf(e);
      n >= 0 && Ce.splice(n, 5), Ce.push(e, e.style.cssText, e.getBBox && e.getAttribute("transform"), u.core.getCache(e), Nr());
    }
  }) : Ce;
};
S.revert = function(s, e) {
  return Kr(!s, e);
};
S.create = function(s, e) {
  return new S(s, e);
};
S.refresh = function(s) {
  return s ? Dt() : (vt || S.register()) && it(!0);
};
S.update = function(s) {
  return ++A.cache && Ke(s === !0 ? 2 : 0);
};
S.clearScrollMemory = Dn;
S.maxScroll = function(s, e) {
  return Ge(s, e ? Fe : fe);
};
S.getScrollFunc = function(s, e) {
  return Ct(be(s), e ? Fe : fe);
};
S.getById = function(s) {
  return Lr[s];
};
S.getAll = function() {
  return b.filter(function(s) {
    return s.vars.id !== "ScrollSmoother";
  });
};
S.isScrolling = function() {
  return !!Ae;
};
S.snapDirectional = Gr;
S.addEventListener = function(s, e) {
  var n = ut[s] || (ut[s] = []);
  ~n.indexOf(e) || n.push(e);
};
S.removeEventListener = function(s, e) {
  var n = ut[s], r = n && n.indexOf(e);
  r >= 0 && n.splice(r, 1);
};
S.batch = function(s, e) {
  var n = [], r = {}, t = e.interval || 0.016, o = e.batchMax || 1e9, a = function(C, L) {
    var O = [], d = [], f = u.delayedCall(t, function() {
      L(O, d), O = [], d = [];
    }).pause();
    return function(w) {
      O.length || f.restart(!0), O.push(w.trigger), d.push(w), o <= O.length && f.progress(1);
    };
  }, l;
  for (l in e)
    r[l] = l.substr(0, 2) === "on" && ce(e[l]) && l !== "onRefreshInit" ? a(l, e[l]) : e[l];
  return ce(o) && (o = o(), X(S, "refresh", function() {
    return o = e.batchMax();
  })), gr(s).forEach(function(c) {
    var C = {};
    for (l in r)
      C[l] = r[l];
    C.trigger = c, n.push(S.create(C));
  }), n;
};
var gn = function(e, n, r, t) {
  return n > t ? e(t) : n < 0 && e(0), r > t ? (t - n) / (r - n) : r < 0 ? n / (n - r) : 1;
}, Ir = function s(e, n) {
  n === !0 ? e.style.removeProperty("touch-action") : e.style.touchAction = n === !0 ? "auto" : n ? "pan-" + n + (Ne.isTouch ? " pinch-zoom" : "") : "none", e === Ie && s(M, n);
}, sr = {
  auto: 1,
  scroll: 1
}, Zn = function(e) {
  var n = e.event, r = e.target, t = e.axis, o = (n.changedTouches ? n.changedTouches[0] : n).target, a = o._gsap || u.core.getCache(o), l = ue(), c;
  if (!a._isScrollT || l - a._isScrollT > 2e3) {
    for (; o && o !== M && (o.scrollHeight <= o.clientHeight && o.scrollWidth <= o.clientWidth || !(sr[(c = Me(o)).overflowY] || sr[c.overflowX])); )
      o = o.parentNode;
    a._isScroll = o && o !== r && !ft(o) && (sr[(c = Me(o)).overflowY] || sr[c.overflowX]), a._isScrollT = l;
  }
  (a._isScroll || t === "x") && (n.stopPropagation(), n._gsapAllow = !0);
}, Fn = function(e, n, r, t) {
  return Ne.create({
    target: e,
    capture: !0,
    debounce: !1,
    lockAxis: !0,
    type: n,
    onWheel: t = t && Zn,
    onPress: t,
    onDrag: t,
    onScroll: t,
    onEnable: function() {
      return r && X(F, Ne.eventTypes[0], vn, !1, !0);
    },
    onDisable: function() {
      return V(F, Ne.eventTypes[0], vn, !0);
    }
  });
}, jn = /(input|label|select|textarea)/i, _n, vn = function(e) {
  var n = jn.test(e.target.tagName);
  (n || _n) && (e._gsapAllow = !0, _n = n);
}, ei = function(e) {
  nt(e) || (e = {}), e.preventDefault = e.isNormalizer = e.allowClicks = !0, e.type || (e.type = "wheel,touch"), e.debounce = !!e.debounce, e.id = e.id || "normalizer";
  var n = e, r = n.normalizeScrollX, t = n.momentum, o = n.allowNestedScroll, a = n.onRelease, l, c, C = be(e.target) || Ie, L = u.core.globals().ScrollSmoother, O = L && L.get(), d = je && (e.content && be(e.content) || O && e.content !== !1 && !O.smooth() && O.content()), f = Ct(C, fe), w = Ct(C, Fe), ie = 1, oe = (Ne.isTouch && y.visualViewport ? y.visualViewport.scale * y.visualViewport.width : y.outerWidth) / y.innerWidth, he = 0, H = ce(t) ? function() {
    return t(l);
  } : function() {
    return t || 2.8;
  }, pe, m, Ue = Fn(C, e.type, !0, o), N = function() {
    return m = !1;
  }, _ = Ye, Se = Ye, Oe = function() {
    c = Ge(C, fe), Se = mt(je ? 1 : 0, c), r && (_ = mt(0, Ge(C, Fe))), pe = at;
  }, h = function() {
    d._gsap.y = Ot(parseFloat(d._gsap.y) + f.offset) + "px", d.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + parseFloat(d._gsap.y) + ", 0, 1)", f.offset = f.cacheID = 0;
  }, de = function() {
    if (m) {
      requestAnimationFrame(N);
      var ge = Ot(l.deltaY / 2), q = Se(f.v - ge);
      if (d && q !== f.v + f.offset) {
        f.offset = q - f.v;
        var i = Ot((parseFloat(d && d._gsap.y) || 0) - f.offset);
        d.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + i + ", 0, 1)", d._gsap.y = i + "px", f.cacheID = A.cache, Ke();
      }
      return !0;
    }
    f.offset && h(), m = !0;
  }, v, pt, Q, Te, De = function() {
    Oe(), v.isActive() && v.vars.scrollY > c && (f() > c ? v.progress(1) && f(c) : v.resetTo("scrollY", c));
  };
  return d && u.set(d, {
    y: "+=0"
  }), e.ignoreCheck = function(D) {
    return je && D.type === "touchmove" && de() || ie > 1.05 && D.type !== "touchstart" || l.isGesturing || D.touches && D.touches.length > 1;
  }, e.onPress = function() {
    m = !1;
    var D = ie;
    ie = Ot((y.visualViewport && y.visualViewport.scale || 1) / oe), v.pause(), D !== ie && Ir(C, ie > 1.01 ? !0 : r ? !1 : "x"), pt = w(), Q = f(), Oe(), pe = at;
  }, e.onRelease = e.onGestureStart = function(D, ge) {
    if (f.offset && h(), !ge)
      Te.restart(!0);
    else {
      A.cache++;
      var q = H(), i, Z;
      r && (i = w(), Z = i + q * 0.05 * -D.velocityX / 0.227, q *= gn(w, i, Z, Ge(C, Fe)), v.vars.scrollX = _(Z)), i = f(), Z = i + q * 0.05 * -D.velocityY / 0.227, q *= gn(f, i, Z, Ge(C, fe)), v.vars.scrollY = Se(Z), v.invalidate().duration(q).play(0.01), (je && v.vars.scrollY >= c || i >= c - 1) && u.to({}, {
        onUpdate: De,
        duration: q
      });
    }
    a && a(D);
  }, e.onWheel = function() {
    v._ts && v.pause(), ue() - he > 1e3 && (pe = 0, he = ue());
  }, e.onChange = function(D, ge, q, i, Z) {
    if (at !== pe && Oe(), ge && r && w(_(i[2] === ge ? pt + (D.startX - D.x) : w() + ge - i[1])), q) {
      f.offset && h();
      var Wt = Z[2] === q, St = Wt ? Q + D.startY - D.y : f() + q - Z[1], Ve = Se(St);
      Wt && St !== Ve && (Q += Ve - St), f(Ve);
    }
    (q || ge) && Ke();
  }, e.onEnable = function() {
    Ir(C, r ? !1 : "x"), S.addEventListener("refresh", De), X(y, "resize", De), f.smooth && (f.target.style.scrollBehavior = "auto", f.smooth = w.smooth = !1), Ue.enable();
  }, e.onDisable = function() {
    Ir(C, !0), V(y, "resize", De), S.removeEventListener("refresh", De), Ue.kill();
  }, e.lockAxis = e.lockAxis !== !1, l = new Ne(e), l.iOS = je, je && !f() && f(1), je && u.ticker.add(Ye), Te = l._dc, v = u.to(l, {
    ease: "power4",
    paused: !0,
    scrollX: r ? "+=0.1" : "+=0",
    scrollY: "+=0.1",
    modifiers: {
      scrollY: In(f, f(), function() {
        return v.pause();
      })
    },
    onUpdate: Ke,
    onComplete: Te.vars.onComplete
  }), l;
};
S.sort = function(s) {
  return b.sort(s || function(e, n) {
    return (e.vars.refreshPriority || 0) * -1e6 + e.start - (n.start + (n.vars.refreshPriority || 0) * -1e6);
  });
};
S.observe = function(s) {
  return new Ne(s);
};
S.normalizeScroll = function(s) {
  if (typeof s > "u")
    return xe;
  if (s === !0 && xe)
    return xe.enable();
  if (s === !1)
    return xe && xe.kill();
  var e = s instanceof Ne ? s : ei(s);
  return xe && xe.target === e.target && xe.kill(), ft(e.target) && (xe = e), e;
};
S.core = {
  // smaller file size way to leverage in ScrollSmoother and Observer
  _getVelocityProp: Ln,
  _inputObserver: Fn,
  _scrollers: A,
  _proxies: zt,
  bridge: {
    // when normalizeScroll sets the scroll position (ss = setScroll)
    ss: function() {
      Ae || ct("scrollStart"), Ae = ue();
    },
    // a way to get the _refreshing value in Observer
    ref: function() {
      return ne;
    }
  }
};
Tn() && u.registerPlugin(S);
export {
  S as ScrollTrigger,
  S as default
};
